import { useNavigate } from 'react-router-dom';
import { startTransition } from 'react';

const useSafeNavigate = () => {
  const navigate = useNavigate();

  return (to, options) => {
    startTransition(() => {
      navigate(to, options);
    });
  };
};

export default useSafeNavigate;
